(() => {
  const WEEKDAYS = [1, 2, 3, 4, 5];

  function londonNow() {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/London",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      }).formatToParts(new Date()).map((p) => [p.type, p.value])
    );

    return new Date(Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour),
      Number(parts.minute),
      Number(parts.second)
    ));
  }

  function isBusinessDay(date) {
    return WEEKDAYS.includes(date.getUTCDay());
  }

  function nextBusinessDay(date) {
    const d = new Date(date);
    do {
      d.setUTCDate(d.getUTCDate() + 1);
    } while (!isBusinessDay(d));
    return d;
  }

  function getDispatchDate(now, cutoffHour, cutoffMinute) {
    const afterCutoff =
      now.getUTCHours() > cutoffHour ||
      (now.getUTCHours() === cutoffHour && now.getUTCMinutes() >= cutoffMinute);

    if (isBusinessDay(now) && !afterCutoff) return new Date(now);
    return nextBusinessDay(now);
  }

  function getDeliveryDate(dispatchDate) {
    return nextBusinessDay(dispatchDate);
  }

  function getCountdownTarget(now, cutoffHour, cutoffMinute) {
    const beforeCutoff =
      isBusinessDay(now) &&
      (
        now.getUTCHours() < cutoffHour ||
        (now.getUTCHours() === cutoffHour && now.getUTCMinutes() < cutoffMinute)
      );

    if (beforeCutoff) {
      const target = new Date(now);
      target.setUTCHours(cutoffHour, cutoffMinute, 0, 0);
      return target;
    }

    const target = nextBusinessDay(now);
    target.setUTCHours(cutoffHour, cutoffMinute, 0, 0);
    return target;
  }

  function ordinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
  }

  function formatDeliveryDate(date) {
    const weekday = new Intl.DateTimeFormat("en-GB", { weekday: "short", timeZone: "UTC" }).format(date);
    const month = new Intl.DateTimeFormat("en-GB", { month: "short", timeZone: "UTC" }).format(date);
    return `${weekday}, ${ordinal(date.getUTCDate())} ${month}`;
  }

  function formatCountdown(ms) {
    const totalMinutes = Math.max(0, Math.floor(ms / 60000));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}hrs ${minutes}mins`;
  }

  function render(el) {
    const dateEl = el.querySelector("[data-edd-date]");
    const countdownEl = el.querySelector("[data-edd-countdown]");
    if (!dateEl || !countdownEl) return;

    const cutoffHour = Number(el.dataset.cutoffHour || 15);
    const cutoffMinute = Number(el.dataset.cutoffMinute || 0);
    const now = londonNow();
    const dispatchDate = getDispatchDate(now, cutoffHour, cutoffMinute);
    const deliveryDate = getDeliveryDate(dispatchDate);
    const countdownTarget = getCountdownTarget(now, cutoffHour, cutoffMinute);

    dateEl.textContent = formatDeliveryDate(deliveryDate);
    countdownEl.textContent = formatCountdown(countdownTarget - now);
  }

  function init(root = document) {
    root.querySelectorAll("[data-edd]:not([data-edd-initialized])").forEach((el) => {
      el.dataset.eddInitialized = "true";
      render(el);

      const timer = setInterval(() => {
        if (!el.isConnected) {
          clearInterval(timer);
          return;
        }

        render(el);
      }, 30000);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
